/**
 * @file FirmwareEvents.ts
 * @description 固件升级事件名称。
 * 用于后续统一升级进度、完成和失败事件。
 */

export const FirmwareEvents = {
  Progress: 'firmware:progress',
  Completed: 'firmware:completed',
  Failed: 'firmware:failed',
  WritedData: 'firmware:writedData',
} as const

export type FirmwareEventName = (typeof FirmwareEvents)[keyof typeof FirmwareEvents]

/** `FirmwareEvents.WritedData` 进度载荷。 */
export interface FirmwareWriteProgress {
  progress: number
}
